import { createAuthClient } from "better-auth/client";
import { emailOTPClient } from "better-auth/client/plugins";

const authClient = createAuthClient({
  baseURL: process.env.REACT_APP_API_URL ?? window.location.origin,
  // Email verification uses 6-digit codes (emailOTP plugin on the backend).
  plugins: [emailOTPClient()],
});

export { authClient };
